export const EXPIRATION_DATE = "Quote can't be valid for more than 30 days";
export const MSX_OPPORTUNITY_ID = "MSX Opportunity ID is missing";
export const INVALID_MSX_OPPORTUNITY_ID = "Invalid MSX Opportunity ID";
export const MSX_OPPORTUNITY_ID_VALIDATION = "Invalid MSX Opportunity ID format";
export const DELIVERY_MODE = "Delivery Mode is missing";
export const DELIVERY_REASON = "Delivery Reason is missing";
export const PAYMENT_TYPE = "Payment Type is missing";
export const PAYMENT_METHOD = "Payment Method is missing";
export const PAYMENT_TERM = "Payment Term is missing";
export const CUSTOMER_PURCHASE_ORDER = "Customer Purchase Order is missing";
export const CUSTOMER_PURCHASE_ORDER_VALIDATION =
  "Special Characters like ^,~,|,*,+,ª,º are not allowed";
export const PREPARED_BY = "Seller Name is missing";
export const INVALID_PHONE_NUMBER =
  "Invalid. Length allowed is between 6 to 30 digits";
export const CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED =
  "Numbers and Special Characters like +,~,* not allowed";
export const SOME_SPECIAL_CHARACTERS_NOT_ALLOWED =
  "Special Characters like +,~,* are not allowed";
export const SOME_PHONE_SPECIAL_CHARACTERS_NOT_ALLOWED =
  "Special Characters like ~,*,alphabet are not allowed";
export const EMAIL_VALIDATION = "Email should be in correct format";

export const decimalValueRegex = /^\d*\.?\d{0,2}$/;
export const wholeNumberRegex = /^\d+$/; // For Japan - only whole numbers, no decimals
export const pattern = /^[a-zA-Z0-9 ]+$/;
export const letters = /^[A-Za-z ]+$/;
export const msxOpportunityIdRegex = /^7-[A-Z0-9]*$/;
export const poNumberRegex = /^[^\^~\|\*\+\u00AA\u00BA]+$/;
export const phoneNumberRegex = /^(?:\+[0-9]{5,29}|[0-9]{6,30})$/;
export const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
// Commented older validation because we have to restrict the number values after @ sign in email field
// export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// export const emailRegex = /^[^\s@]+@(?!.*\d)[^\s@]+\.[^\s@]+$/
export const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const allowPhoneSpecialCharacterExcludingSome =
 /^[^[\^*|~\u00AA\u00BA]+$/;
export const allowSpecialCharacterExcludingSome = /^[^[\^*|~+\u00AA\u00BA]+$/;
export const allowCharactersAndSpecialSymbols = /^[^\d\^*|~+\u00AA\u00BA]+$/;
export const INCOMPLETE_BUNDLE_MESSAGE =
  "Bundle incomplete, contact category manager.";
